module.exports = __webpack_public_path__ + "img/labelsLikesOrdered.a81ed09c.svg";